
  import { css } from 'lit';
  export const styles = css`:host{background:var(--background)}[part=header]{background:var(--header-background);color:var(--header-color)}[part=typing-dot]::after{background:var(--progress-indicator-color)}`;
  